import React from "react";
import { css } from "aphrodite";
import { NavLink } from "react-router-dom";
import styles from "./new-user-styles";
import { FilledGreenButton } from "../common";
import AppStyles from "../../library/appStyles";

import { FaEnvelope, FaCheckCircle } from "react-icons/fa";

const NewUserView = props => (
  <div className={css(styles.root)}>
    <img
      src={require("../../assets/kiffgo/logo-green.svg")}
      className={css(styles.logo)}
    />
    {!props.detailsSetSuccessfully && (
      <React.Fragment>
        <h1 className={css(styles.title)}>Welcome</h1>
        <div className={css(styles.description)}>
          Please fill below form to get started with Kiffgo
        </div>

        <div className={css(styles.content)}>
          <div style={{ position: "relative" }}>
            <div className={css(styles.inputIconContainer)}>
              <FaEnvelope className={css(styles.inputIcon)} />
            </div>
            <input
              placeholder={"First Name"}
              className={css(styles.input)}
              value={props.firstName}
              onKeyDown={props.handleKeyDown}
              onChange={props.onChangeFirstName}
            />
          </div>

          <div style={{ position: "relative" }}>
            <div className={css(styles.inputIconContainer)}>
              <FaEnvelope className={css(styles.inputIcon)} />
            </div>
            <input
              placeholder={"Last Name"}
              className={css(styles.input)}
              value={props.lastName}
              onKeyDown={props.handleKeyDown}
              onChange={props.onChangeLastName}
            />
          </div>

          <div style={{ position: "relative" }}>
            <div className={css(styles.inputIconContainer)}>
              <FaEnvelope className={css(styles.inputIcon)} />
            </div>
            <input
              placeholder={"Password"}
              type={"password"}
              className={css(styles.input)}
              value={props.password}
              onKeyDown={props.handleKeyDown}
              onChange={props.onChangePassword}
            />
          </div>

          <div style={{ position: "relative" }}>
            <div className={css(styles.inputIconContainer)}>
              <FaEnvelope className={css(styles.inputIcon)} />
            </div>
            <input
              placeholder={"Confirm Password"}
              type={"password"}
              className={css(styles.input)}
              value={props.confirmPassword}
              onKeyDown={props.handleKeyDown}
              onChange={props.onChangeConfirmPassword}
            />
          </div>

          <FilledGreenButton
            disabled={props.disabled}
            title={"Create Account"}
            onClick={props.resetNewUser}
            loading={props.loading}
          />
        </div>
      </React.Fragment>
    )}

    {props.detailsSetSuccessfully && (
      <React.Fragment>
        <div className={css(styles.content)}>
          <div className={css(styles.tickWrapper)}>
            <FaCheckCircle className={css(styles.tickIcon)} />
          </div>
          <h4 className={css(styles.innerTitle)}>Account created.</h4>
          <div className={css(styles.description)}>
            Please get logged in to explore Kiffgo Dashboard.
          </div>
        </div>

        <NavLink to={"/"} style={AppStyles.noUnderline}>
          <FilledGreenButton title={"Login"} />
        </NavLink>
      </React.Fragment>
    )}
  </div>
);

export default NewUserView;



// WEBPACK FOOTER //
// ./src/components/new-user/new-user-view.js